import type { CalendarEventContextMenuStore } from './schema/CalendarEventContextMenuStore';
import { createStore } from 'satcheljs';
import type { ViewType } from 'owa-calendar-actions';

const getStore = createStore<CalendarEventContextMenuStore>('calendarEventContextMenuStore', {
    sourceId: '' as ViewType,
    initializedEventId: null,
    viewState: {
        itemId: null,
        parentFolderId: '',
        clickEvent: null,
    },
});

export default getStore;
